// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1h9tO","paramInput":"JobSimulator_paramInput__xIKwg","input":"JobSimulator_input__2I4zu"};